<template>
  
  <v-flex xs12 sm12 md12 class="mt-3">
    <v-card>
      <v-card-text class="mt-0">

        <BoxHeader 
          :questionObj="question" 
          title="Slider">
        </BoxHeader>

        <!-- Question -->
        <v-textarea 
          :counter="250"
          label="Write question here"
          auto-grow
          autofocus
          v-model="questionText"
          v-on:input="setTextForQuestionObj($event)" 
          hint="Example: how many boxes to you need?"
          :rules="[rules.required]"
        ></v-textarea>

        <v-layout row class="mt-5">
          <v-flex shrink style="width: 60px">
            <v-text-field
              v-model="min"
              class="mt-0 mr-1"
              hide-details
              single-line
              type="number"
            ></v-text-field>
          </v-flex>

          <v-slider
            :value="(this.min + this.max) / 2"
            always-dirty
            thumb-label="always"
            :min="min"
            :max="max"
          ></v-slider>

          <v-flex shrink style="width: 60px">
            <v-text-field
              v-model="max"
              class="mt-0 ml-1"
              hide-details
              single-line
              type="number"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <p class="text-xs-right"><small><i>*You can set the minimum and maxium.</i></small></p>

      </v-card-text>

    </v-card>
  </v-flex>

</template>

<script>
// @ is an alias to /src
import BoxHeader from '@/components/questionForms/BoxHeader.vue'

export default {
  name: "sliderbox",
  components: {
    BoxHeader
  },
  props: {
    question: Object
  },
  data: () => ({
    questionText: null,
    min : null,
    max : null,
    rules: {
      required: value => !!value || 'Cannot Be Empty.'
    }
  }),
  watch: {
    min: function (val) {
      if (!val) {
        this.min = 0;
        return
      }
      this.min = parseInt(val);
      this.setMinMax();
    },
    max: function (val) {
      if (!val) {
        this.max = 0;
        return
      }
      this.max = parseInt(val);
      this.setMinMax();
    }
  },
  created(){
    this.questionText = this.question.text;
    this.min = this.question.min !== undefined ? this.question.min : 0;
    this.max = this.question.max !== undefined ? this.question.max : 100;
  },
  methods: {
    setTextForQuestionObj(text) {
      this.$store.commit('setTextForQuestionObj', {questionObj: this.question, text:text});
    },
    setMinMax(){
      this.question.min = this.min;
      this.question.max = this.max;
    }
  }
};
</script>

<style scoped>

</style>